import './main.less';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';

import { actions, selectors } from './';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import EditorForm from './components/form/main';

const Main = renderViewsState(props => (
	<Animate>
		<div className='container__content'>
			<div className='container__content-title'>
				<div className='container__content-title-position'>
					<Link
						to='/guarant-approve-requests'
						className='link'
					>{props.intl('Return to list of guarants')}</Link>
				</div>
				<div className='container__content-title-position'>
					<h2 className='title'>{props.intl('Guarants editor')}</h2>
				</div>
			</div>
			<div className='container__content-body'>
				<div className='form-container guarant-editor-container'>
					<EditorForm {...props} initialValues={props.initialValues} />
				</div>
			</div>
		</div>
	</Animate>
), 'edit');

export default connect(
	state => ({
		data: selectors.getData(state),
		formSelectOptions: selectors.getFormSelectOptions(state),
		initialValues: selectors.getInitialValues(state),
		can: selectors.getCan(state),
		calendar: selectors.getCalendar(state),
		datepicker: selectors.getDatepicker(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/guarant-approve-register/editor/main.js